import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';

import { getDevicePerformanceData } from './devicePerformance';

export const useLogDevicePerformance = () => {
  useEffect(() => {
    const logDevicePerformanceData = async () => {
      const devicePerformance = await getDevicePerformanceData();
      datadogRum.addAction('devicePerformance', devicePerformance);
    };
    logDevicePerformanceData();
  }, []);
};
